module.exports = __webpack_public_path__ + "img/Ele3.0e6a43d9.jpg";